/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerFindActivitiesQueryResponse, TasksControllerFindActivitiesPathParams, TasksControllerFindActivitiesQueryParams, TasksControllerFindActivities401, TasksControllerFindActivities403 } from "../../models/tasksController/TasksControllerFindActivities";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { tasksControllerFindActivities } from "../../clients/tasksService/tasksControllerFindActivities";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const tasksControllerFindActivitiesQueryKey = (id: TasksControllerFindActivitiesPathParams["id"], params: TasksControllerFindActivitiesQueryParams = {}) => [{
  url: '/api/v1/tasks/:id/activities',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TasksControllerFindActivitiesQueryKey = ReturnType<typeof tasksControllerFindActivitiesQueryKey>;
export function tasksControllerFindActivitiesQueryOptions(id: TasksControllerFindActivitiesPathParams["id"], params?: TasksControllerFindActivitiesQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = tasksControllerFindActivitiesQueryKey(id, params);
  return queryOptions<TasksControllerFindActivitiesQueryResponse, ResponseErrorConfig<TasksControllerFindActivities401 | TasksControllerFindActivities403>, TasksControllerFindActivitiesQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return tasksControllerFindActivities(id, params, config);
    }
  });
}

/**
 * @summary Curated activity history for a task
 * {@link /api/v1/tasks/:id/activities}
 */
export function useTasksControllerFindActivities<TData = TasksControllerFindActivitiesQueryResponse, TQueryData = TasksControllerFindActivitiesQueryResponse, TQueryKey extends QueryKey = TasksControllerFindActivitiesQueryKey>(id: TasksControllerFindActivitiesPathParams["id"], params?: TasksControllerFindActivitiesQueryParams, options: {
  query?: Partial<QueryObserverOptions<TasksControllerFindActivitiesQueryResponse, ResponseErrorConfig<TasksControllerFindActivities401 | TasksControllerFindActivities403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? tasksControllerFindActivitiesQueryKey(id, params);
  const query = useQuery({
    ...tasksControllerFindActivitiesQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TasksControllerFindActivities401 | TasksControllerFindActivities403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}